import React, { useState, useEffect } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { tokenLoader } from "src/util/auth";
import LoginPage, { action as authAction } from "src/pages/Login/Login";
import Events from "src/components/Events/Events";
import ContextContainer from "src/components/ContextContainer";
import PowerContextContainer from "src/components/PowerContextContainer";
import DashboardLayout from "src/pages/DashBoardLayout/DashboardLayout";
import Split from "src/components/Split/Split";
import HomePage from "src/pages/Home/Home";
import ErrorPage from "src/pages/Error/Error";
import Windowing from "src/components/Windowing/windowing";
import Unauthorized from "src/pages/ErrorPages/unauthorized";
import {action as logoutAction} from './logout';
import Deals,{loader as DealsLoder} from "./pages/Deals/Deals";
import AccountManagementPage from "src/pages/AccountManagement/AccountManagement";
import ExploreComplexesPage, {
  loader as complexesLoader,
} from "src/pages/ExploreSites/ExploreSites";
import ComplexDetailPage, {
  loader as complexDetailLoader,
  // action as deleteComplexAction,
} from "src/pages/ComplexDetail/ComplexDetail.jsx";
import NewComplexPage from "src/pages/ComplexWizard/ComplexWizard";
import BuildingDetailPage, {
  loader as buildingDetailLoader,
  // action as deleteComplexAction,
} from "src/pages/BuildingDetail/BuildingDetail";
import AssetDetailPage, {
  loader as AssetDetailLoader,
  // action as deleteComplexAction,
} from "src/pages/AssetDetail/AssetDetail";
import MonitoringNew, {
  loader as monitoringNewLoader,
} from "src/components/Monitoring/monitoring";
import Layout from "src/components/TicketingComponents/layout";
import Board, {
  loader as Boardloader,
} from "src/components/TicketingComponents/Board";
import Contract, {
  loader as ContractsLoader,
} from "src/components/TicketingComponents/contract";
import Reports from "src/components/TicketingComponents/Reports";
import Issues, {
  loader as CompanyLoader,
} from "src/components/TicketingComponents/Issues";
import Alerts from "src/components/TicketingComponents/Alerts";
import MntOperator, {
  loader as OperatorLoader,
} from "src/components/TicketingComponents/MntOperator";
import Trash from "src/components/TicketingComponents/Trash";
import Tags from "src/components/TicketingComponents/Tags";
import BuildingForm from "src/components/BuildingDetails/newBuilding";
import AssetForm from "src/components/AssetDetails/AssetForm";
import ReportsHistory, {
  loader as ReportsLoader,
} from "src/components/ReportHistory/reportsHistory";
import Notifications, {
  loader as AlarmsLoader,
} from "src/pages/AlertsNotifications/alerts&Notifications";
import Setup from "src/pages/StartUp/StartupWizard";
import "src/App.css";
import Tasks,{loader as TasksLoader} from "src/pages/Tasks/tasks";
import NotebookPage,{loader as NotesLoader} from "src/components/NoteBook/notebook";
import SiteMonitor, { loader as MonitoringNewLoader } from "src/pages/SiteMonitorDetail/SiteMonitorDetail";
import Operator from "src/components/TicketingComponents/MntOperator";
import DataExplorer from "src/pages/DataExplorer/DataExplorer";
import ZoomedOutMonitoring ,{loader as ZoomedOutMonitoringLoader} from "src/components/Monitoring/ExploreSitesinMapsLevel1";
import ZoomedOutMonitoringLevel2 from "src/components/Monitoring/ExploreSitesinMapsLevel2";
import ZoomedOutMonitoringSiteDetail,{loader as ZoomedOutMonitoringSiteDetailLoader} from "src/components/Monitoring/ExploreSiteDetailsinMaps";
function App(props) {
  const routes = [
    {
      path: "",
      element: <ContextContainer />,
      id: "context",
      children: [
        {
          path: "/auth",
          element: <LoginPage />,
          errorElement: <ErrorPage />,
          action: authAction,
        },
        {
          path: "/setup",
          element: <Setup />,
          errorElement: <ErrorPage />,
        },

        // {
        //   path: "/events",
        //   element: <Events />,
        // },

        {
          path: "/",
          element: <DashboardLayout />,
          errorElement: <ErrorPage />,
          id: "root",
          loader: tokenLoader,
          children: [
            { index: true, element: <HomePage /> },
            {
              path: "dashboard",
              id: "dashboard",
              errorElement: <ErrorPage />,
              children: [
                {
                  index: true,
                  element: <HomePage />,
                  // loader: eventsLoader,
                },
                {
                  path: "account-management",
                  id: "account-management",
                  element: <AccountManagementPage />,
                  // action: deleteEventAction,
                },
                {
                  path: "unauthorized",
                  element: <Unauthorized />,
                },
                {
                  path: "tasks",
                  id: "tasks",
                  element: <Tasks />,
                  loader: TasksLoader,
                  // action: deleteEventAction,
                },

                {
                  path: "explore-complexes",
                  errorElement: <ErrorPage />,
                  children: [
                    {
                      index: true,
                      element: <ZoomedOutMonitoring />,
                      id: "zoomMonitoring",
                      // action: manipulateEventAction,
                      loader: ZoomedOutMonitoringLoader,
                    },
                    {
                     path:"complexListMode",
                      element: <ExploreComplexesPage />,
                      // action: manipulateEventAction,
                      loader: complexesLoader,
                    },
                    {
                      
                      path:"level2",
                      element: <ZoomedOutMonitoringLevel2 />,
                      id: "zoomMonitoringLevel2",
                      // action: manipulateEventAction,
                      loader: ZoomedOutMonitoringLoader,
                    },
                    {
                     
                      path:"siteDetailMap/:siteId",
                      element: <ZoomedOutMonitoringSiteDetail />,
                      id: "zoomMonitoringSiteDetail",
                      // action: manipulateEventAction,
                      loader: ZoomedOutMonitoringSiteDetailLoader,
                    },   
                    {
                      path: "new-complex",
                      element: <NewComplexPage />,
                      // loader: checkAuthLoader,
                    },
                    {
                      path: "unauthorized",
                      element: <Unauthorized />,
                      // loader: checkAuthLoader,
                    },
                    {
                      path: ":complexId",
                      id: "complex-detail",
                      loader: complexDetailLoader,
                      children: [
                        {
                          index: true,
                          element: <ComplexDetailPage />,
                          // loader: checkAuthLoader,
                          // action: deleteEventAction,
                        },
                        {
                          path: "new-building",
                          element: <BuildingForm />,
                          // action: manipulateEventAction,
                          // loader: checkAuthLoader,
                        },
                        {
                          path: "building/:buildingId",
                          id: "building-detail",
                          // action: manipulateEventAction,
                          loader: buildingDetailLoader,
                          children: [
                            {
                              index: true,
                              element: <BuildingDetailPage />,
                              // loader: checkAuthLoader,
                              // action: deleteEventAction,
                            },
                            {
                              path: "new-asset",
                              element: <AssetForm />,
                              // action: manipulateEventAction,
                              // loader: checkAuthLoader,
                            },
                            {
                              path: "asset/:assetId",
                              element: <AssetDetailPage />,
                              id: "asset-detail",
                              // action: manipulateEventAction,
                              loader: AssetDetailLoader,
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  path: "reports-history",
                  id: "reports-history",
                  element: <ReportsHistory />,
                  // action: manipulateEventAction,
                  loader: ReportsLoader,
                },
                {
                  path: "notebook",
                  id: "notebook",
                  element: <NotebookPage />,
                  loader: NotesLoader,
                },
                {
                  path: "data-explorer",
                  id: "data-explorer",
                  element: <DataExplorer />,
                  // action: manipulateEventAction,
                  // loader: checkAuthLoader,
                },
                {
                  path: "notifications",
                  id: "notifications1",
                  element: <Notifications />,
                  // action: manipulateEventAction,
                  // loader: checkAuthLoader,
                },
                {
                  path: "alerts-and-notifications",
                  id: "notifications",
                  element: <Notifications />,
                  loader: AlarmsLoader,
                  // action: manipulateEventAction,
                  // loader: checkAuthLoader,
                },
                {
                  path: "window",
                  id: "window",
                  element: <Windowing />,
                  // action: manipulateEventAction,
                  // loader: checkAuthLoader,
                },
                {
                  path: "deals",
                  id: "deals",
                  element: <Deals />,
                  loader: DealsLoder
                  // action: manipulateEventAction,
                  // loader: checkAuthLoader,
                },

                // {
                //   path: "alerts-and-notification/endpoints",
                //   id: "endpoints",
                //   element: <Endpoints />,
                //   // action: manipulateEventAction,
                //   // loader: checkAuthLoader,
                // },
                {
                  path: "monitoring",
                  element: <PowerContextContainer />,
                  children: [
                    {
                      index: true,
                      id: "monitoring-new",
                      element: <MonitoringNew />,
                      loader: monitoringNewLoader,
                    },
                    {
                      path: "site/:siteId",
                      id: "site-monitor",
                      element: <SiteMonitor />,
                      // action: manipulateEventAction,
                      loader: MonitoringNewLoader,
                    },
                  ],
                },
                {
                  path: "ticketing",
                  id: "ticketing",
                  element: <Layout />,
                  children: [
                    {
                      path: "board",
                      element: <Board />,
                      id: "board-detail",
                      // action: manipulateEventAction,
                      loader: Boardloader,
                    },
                    {
                      path: "contracts",
                      element: <Contract />,
                      id: "contract",
                      // action: manipulateEventAction,
                      loader: ContractsLoader,
                    },
                    {
                      path: "issues",
                      element: <Issues />,
                      id: "company",
                      loader: CompanyLoader,
                      // action: manipulateEventAction,
                      // loader: checkAuthLoader,
                    },
                    {
                      path: "operators",
                      element: <MntOperator />,
                      id: "operator",
                      loader: OperatorLoader,
                      // action: manipulateEventAction,
                      // loader: checkAuthLoader,
                    },
                    {
                      path: "trash",
                      element: <Trash />,
                      // action: manipulateEventAction,
                      // loader: checkAuthLoader,
                    },
                    {
                      path: "tags",
                      element: <Tags />,
                      // action: manipulateEventAction,
                      // loader: checkAuthLoader,
                    },
                  ],
                },
              ],
            },
            {
              path: "logout",
              action: logoutAction,
            },
          ],
        },
      ],
    },
  ];

  const router = createBrowserRouter(routes);

  return <RouterProvider router={router}></RouterProvider>;
}

export default App;
